import { createMbpEmbedClient } from '@govflanders/mbp-embed-sdk';

export const environment = {
    production: true,
    env: 'prod',
    // TODO update client id
    mbpClient: createMbpEmbedClient('89c1dccf-5650-4f6c-96fe-af15fb9929ea'),
    devProviders: [],
};
